/** Marca Prompt & Steam da CodeCoffee, usada no crédito de desenvolvimento. */
export function CodeCoffeeLogo({ tamanho = 20 }: { tamanho?: number }) {
  return (
    <svg width={tamanho} height={tamanho} viewBox="0 0 32 32" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M9 12 15.5 17.5 9 23" stroke="#e8a33d" strokeWidth="2.75" />
      <rect x="18.5" y="20.25" width="7" height="2.75" rx="1.375" fill="#e8a33d" />
      <path d="M16.5 13c1.5-1.8 3.5-1.8 5 0s3.5 1.8 5 0" stroke="#e8a33d" strokeWidth="2.5" opacity=".85" />
      <path d="M17.5 8c1.5-1.8 3.5-1.8 5 0s3.5 1.8 5 0" stroke="#45d9e8" strokeWidth="2.25" opacity=".6" />
    </svg>
  );
}
